import { mapState } from 'vuex';
import tenantPickerMixin from '../core/tenant/pickerMixin';
import ApiService from '../../services/apiService';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import { get } from 'lodash';
export default {
  name: 'CoreDialogEula',
  components: {
    MarkdownItVueLight
  },
  mixins: [tenantPickerMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      termsAndConditions: '',
      title: ''
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {
    userId() {
      if (!this.userId) {
        return;
      }
      ApiService.getUser(this, this.userId).then(user => {
        ApiService.getTermsAndConditions(user.access[0].tenantId).then(result => {
          this.termsAndConditions = get(result, `termsAndConditions[0].termsAndConditions[${localStorage.getItem('language') || 'de'}]`);
          this.title = get(result, `termsAndConditions[0].termsAndConditions.title[${localStorage.getItem('language') || 'de'}]`);
        }).catch(error => {
          console.error(error);
        });
      }).catch(error => {
        console.error(error);
      });
    }
  },
  methods: {
    handleAccept() {
      ApiService.userAcceptEula().then(() => {
        this.$store.dispatch('authentication/verify').catch(() => {
          this.$snack('Error while accepting the agreement', 'error');
        });
      }).catch(() => {
        this.$snack('Error while accepting the agreement', 'error');
        this.handleDecline();
      });
    },
    handleDecline() {
      this.$store.dispatch('authentication/logout').then(() => {
        this.$router.push('/login');
      }).catch(() => {
        // empty
      });
    }
  }
};